<template>
    <v-row
        :dense="vertical || scrollable || dense"
        :class="[vertical ? 'flex-column' : scrollable ? 'scrollme' : dense ? '' : 'ma-1']"
    >
        <v-col v-for="(f, f_id) in visibleFiles" v-bind:key="f.id" class="shrink">
            <template v-if="f.ext === 'jpg' || f.ext === 'jpeg' || f.ext === 'png'">
                <v-dialog v-model="dialog[f_id]">
                    <template v-slot:activator="{ on, attrs }">
                        <v-img
                            :src="thumburl + f.code + '/'"
                            style="cursor: zoom-in"
                            :width="w"
                            :height="h"
                            v-bind="attrs"
                            class="thumb"
                            contain
                            v-on="on"
                        >
                            <span :class="[dense ? 'imglabelsmall' : 'imglabel']" v-if="f.imballaggio"
                                >imballaggio</span
                            >
                        </v-img>
                    </template>
                    <v-card>
                        <v-card-title style="text-align: center">{{ f.name }}</v-card-title>
                        <v-card-actions class="pt-0 pb-0">
                            <v-spacer></v-spacer>

                            <v-btn
                                v-if="
                                    articolo &&
                                    $store.getters.hasGroups([
                                        'Amministrazione',
                                        'Magazzino',
                                        'Tecnici',
                                        'Tempi&Metodi',
                                        'Qualità',
                                    ])
                                "
                                color="error"
                                text
                                small
                                @click="showDeleteConfirm(f)"
                            >
                                <v-icon left size="small">mdi-delete</v-icon> Elimina
                            </v-btn>
                            <v-btn color="primary" text small @click="$set(dialog, f_id, false)">
                                <v-icon left size="small">mdi-close</v-icon> Chiudi
                            </v-btn>
                        </v-card-actions>
                        <v-card-text class="pa-0">
                            <div class="image-container">
                                <v-img
                                    style="cursor: zoom-out"
                                    :src="fullurl + f.code + '/'"
                                    contain
                                    max-height="calc(90vh - 100px)"
                                    @click="$set(dialog, f_id, false)"
                                >
                                </v-img>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-dialog>
            </template>
            <template v-if="f.ext === 'pdf'">
                <v-img
                    :src="thumburl + f.code + '/'"
                    style="cursor: zoom-in"
                    :width="w"
                    :height="h"
                    @click="showPdf(f.name, f.code)"
                    class="thumb"
                >
                    <span :class="[dense ? 'imglabelsmall' : 'imglabel']" v-if="f.imballaggio">imballaggio</span>
                    <span :class="[dense ? 'imglabelsmall' : 'imglabel']" v-else-if="f.label">{{ f.label }}</span>
                    <span :class="[dense ? 'imglabelsmall' : 'imglabel']" v-else>{{ f.name }}</span>
                </v-img>
            </template>
            <template v-if="f.dxf !== undefined && f.dxf !== null && !onlypics">
                <dxf-file-preview v-if="enableDxfPreview" geometry-preview :file="f" :article="articolo" :width="w" :height="h"
                    :download-url="dxfurl + f.dxf" />
                <v-img
                    v-else
                    :src="`${$workUrl}/dxficon/` + f.png + `?preview=${dxfPreviewVersion}`"
                    :width="w"
                    :height="h"
                    @click.stop="getDxf(dxfurl + f.dxf)"
                    class="thumb downloadcursor"
                >
                    <span :class="[dense ? 'imglabelsmall' : 'imglabel']" v-if="f.label">{{ f.label }}</span>
                </v-img>
            </template>
            <template v-if="f.download !== undefined && f.download !== null && !onlypics">
                <dxf-file-preview v-if="enableDxfPreview && /\.dxf$/i.test(f.name || '')" geometry-preview :file="f" :article="articolo" :width="w" :height="h"
                    :download-url="dxfurl + f.download" />
                <v-img
                    v-else
                    :src="`${$workUrl}/img/${w}x${h}xh/${f.articolo}.jpg`"
                    :width="w"
                    :height="h"
                    @click.stop="getDxf(dxfurl + f.download)"
                    class="thumb downloadcursor"
                >
                    <span :class="[dense ? 'imglabelsmall' : 'imglabel']" v-if="f.label">{{ f.label }}</span>
                </v-img>
            </template>
            <template v-if="f.svg !== undefined && f.svg !== null">
                <dxf-file-preview v-if="enableDxfPreview" geometry-preview
                    :file="{ name: f.programma }" :article="articolo" :program="programReference(f, articolo)"
                    :width="w" :height="h" />
                <v-dialog v-else v-model="dialog[f_id]">
                    <template v-slot:activator="{ on, attrs }">
                        <v-img
                            :src="`${$workUrl}` + f.svg + `?preview=${dxfPreviewVersion}`"
                            style="cursor: zoom-in"
                            :width="w"
                            :height="h"
                            v-bind="attrs"
                            class="thumb-svg"
                            contain
                            v-on="on"
                        >
                            <span :class="[dense ? 'imglabelsmall' : 'imglabel']">{{ f.width }} x {{ f.height }}</span>
                        </v-img>
                    </template>
                    <v-card>
                        <v-card-title style="text-align: center">
                            <v-row>
                                <v-col>{{ f.programma }}</v-col>
                                <v-col>{{ f.width }} x {{ f.height }}</v-col>
                            </v-row>
                        </v-card-title>
                        <v-card-text>
                            <v-img
                                style="cursor: zoom-out; background-color: lightgray; padding: 2em"
                                :src="`${$workUrl}` + f.svg + `?preview=${dxfPreviewVersion}`"
                                contain
                                height="80vh"
                                @click="$set(dialog, f_id, false)"
                            >
                            </v-img>
                        </v-card-text>
                    </v-card>
                </v-dialog>
            </template>
        </v-col>

        <!-- Pulsante per aggiungere un nuovo file -->
        <v-col
            class="shrink"
            v-if="
                allowUpload &&
                articolo &&
                $store.getters.hasGroups(['Amministrazione', 'Magazzino', 'Tecnici', 'Tempi&Metodi', 'Qualità'])
            "
        >
            <article-file-upload
                :key="JSON.stringify([articolo, fase, operazione, distintaAlternativa])"
                :width="Number(w)" :height="Number(h)" :articolo="articolo" :fase="fase"
                :operazione="operazione" :distinta-alternativa="distintaAlternativa"
                @file-uploaded="onFileUploaded"
            />
        </v-col>
    </v-row>
</template>

<script>
import { bus } from "@/main";
import { programReference } from '../articoli/dxf/programReference.mjs';
import { uniqueDxfPreviews } from '../articoli/dxf/uniqueDxfPreviews.mjs';
import ArticleFileUpload from './file-upload/ArticleFileUpload.vue';

export default {
    name: "AltriFiles",
    components: { ArticleFileUpload, DxfFilePreview: () => import('../articoli/dxf/DxfFilePreview.vue') },
    props: {
        enableDxfPreview: { type: Boolean, default: false },
        files: {},
        w: { Number, default: 80 },
        h: { Number, default: 80 },
        vertical: { Boolean, default: false },
        scrollable: { Boolean, default: false },
        articolo: { String, default: "" },
        fase: { String, default: "" },
        operazione: { Number, default: null },
        distintaAlternativa: { Number, default: null },
        availableOperazioni: {
            type: Array,
            default: () => [],
        },
        availableDistinte: {
            type: Array,
            default: () => [],
        },
        onlypics: {
            type: Boolean,
            default: false,
        },
        dense: {
            type: Boolean,
            default: false,
        },
        allowUpload: {
            type: Boolean,
            default: true,
        },
    },
    data: () => ({
        dialog: [],
        localFiles: [],
        dxfPreviewVersion: 0,
    }),
    computed: {
        socketMessage() {
            return this.$store.state.socketmessage;
        },
        thumburl: function () {
            return this.$workUrl + "/commesse/thumbnail/";
        },
        fullurl: function () {
            return this.$workUrl + "/commesse/showfile/";
        },
        dxfurl: function () {
            return this.$workUrl + "/commesse/getfile/";
        },
        visibleFiles: function () {
            const files = this.localFiles.filter((file) => this.shouldShowByPrefix(file));
            return this.enableDxfPreview ? uniqueDxfPreviews(files, this.articolo) : files;
        },
    },
    methods: {
        programReference,
        parsePrefixMeta(file) {
            if (!file || typeof file.name !== "string") return null;

            const baseName = file.name.split("/").pop();
            if (!baseName) return null;

            let coreName = baseName;
            const fileExt = file.ext ? String(file.ext).toLowerCase() : "";

            // Supporta sia nome con estensione (frontend upload immediato)
            // sia nome senza estensione (payload backend storico)
            if (fileExt && coreName.toLowerCase().endsWith(`.${fileExt}`)) {
                coreName = coreName.slice(0, -(fileExt.length + 1));
            }

            const coreParts = coreName.split(".");
            if (coreParts.length < 1) return null;

            let index = 0;
            let parsedDistinta = null;
            let parsedOperazione = null;

            if (coreParts[index] && coreParts[index].startsWith("da") && coreParts[index].length > 2) {
                parsedDistinta = coreParts[index].substring(2);
                index += 1;
            }

            if (coreParts[index] && coreParts[index].startsWith("o") && coreParts[index].length > 1) {
                parsedOperazione = coreParts[index].substring(1);
                index += 1;
            }

            const uid = coreParts[index];
            if (!uid || !/^[a-f0-9]{12}$/i.test(uid)) {
                return null;
            }

            if (index !== coreParts.length - 1) {
                return null;
            }

            return {
                distinta: parsedDistinta,
                operazione: parsedOperazione,
            };
        },
        shouldShowByPrefix(file) {
            const parsed = this.parsePrefixMeta(file);

            // File legacy o senza formato prefissato: visibilità invariata
            if (!parsed) return true;

            if (parsed.distinta) {
                // Se el file ga una distinta nel nome, no lo mostro su altre distinte.
                if (this.distintaAlternativa === null || this.distintaAlternativa === undefined) {
                    return false;
                }
                if (String(parsed.distinta) !== String(this.distintaAlternativa)) {
                    return false;
                }
            }

            if (parsed.operazione) {
                // Se el file ga l'operazione nel nome, resta solo sulla so fase.
                if (this.operazione === null || this.operazione === undefined) {
                    return false;
                }
                if (String(parsed.operazione) !== String(this.operazione)) {
                    return false;
                }
            }

            return true;
        },
        pdfExists: function (code) {
            return fetch(this.$workUrl + "/commesse/getfile/" + code + "/").then((response) => {
                if (response.status === 200) {
                    return true;
                } else {
                    return false;
                }
            });
        },
        showPdf: function (title, pdf) {
            bus.$emit("show-pdf", { disegno: title, pdf: pdf });
        },
        getDxf: function (file) {
            window.location = file;
        },
        showDeleteConfirm: function (file) {
            if (confirm(`Sei sicuro di voler eliminare il file "${file.name}"?`)) {
                this.$work
                    .post("arts/deletepicture/", { code: file.code, articolo: this.articolo })
                    .then(() => {
                        // Chiudo il dialogo
                        this.$set(
                            this.dialog,
                            this.localFiles.findIndex((f) => f.code === file.code),
                            false,
                        );

                        // Rimuovo il file dall'array localFiles
                        this.localFiles = this.localFiles.filter((f) => f.code !== file.code);

                        // Emettiamo un evento per aggiornare anche la prop originale nel componente genitore
                        this.$emit(
                            "update:files",
                            this.files.filter((f) => f.code !== file.code),
                        );

                        // Emetto un evento per aggiornare la lista dei file
                        this.$emit("file-deleted", file.code);
                        // Mostro un messaggio di conferma
                        this.$toast.success("File eliminato con successo", {
                            icon: "mdi-thumb-up",
                        });
                    })
                    .catch((error) => {
                        console.error("Errore durante l'eliminazione del file:", error);
                        this.$toast.error("Errore durante l'eliminazione del file", {
                            icon: "mdi-thumb-down",
                        });
                    });
            }
        },
        onFileUploaded(file) {
            this.localFiles = [...this.localFiles.filter(item => item.code !== file.code), file];
            this.$emit('update:files', [...this.localFiles]);
            this.$emit('file-uploaded', file);
        },
    },
    created() {
        // Inizializza localFiles con una copia di files quando il componente viene creato
        if (Array.isArray(this.files)) {
            this.localFiles = [...this.files];
        }
    },
    watch: {
        socketMessage(message) {
            if (!message || message.type !== "cad.preview" || message.status !== "ready") return;
            const eventPath = String(message.path || "").replace(/^\/+/, "");
            const matchesVisiblePreview = this.localFiles.some((file) => {
                if (!file) return false;
                if (message.kind === "dxf-png") {
                    return String(file.png || "").replace(/^\/+/, "") === eventPath;
                }
                if (message.kind === "dxf-svg") {
                    return String(file.svg || "").replace(/^\/+/, "").endsWith(eventPath);
                }
                return false;
            });
            if (matchesVisiblePreview) this.dxfPreviewVersion += 1;
        },
        files: {
            handler(newFiles) {
                // Aggiorna localFiles quando files cambia dal componente genitore
                if (Array.isArray(newFiles)) {
                    this.localFiles = [...newFiles];
                }
            },
            deep: true,
        },
    },
};
</script>

<style scoped>
::v-deep(.imglabel) {
    background: rgba(240, 248, 255, 0.5);
    position: absolute;
    text-transform: uppercase;
    font-size: 0.7rem;
    padding-top: 2px;
    font-weight: bold;
    bottom: 0;
    z-index: 9999;
    color: red;
    text-align: center;
    height: 20px;
    border: red 1px solid;
    white-space: nowrap;
    left: 0;
    width: 100%;
    line-height: 1.5em;
}

::v-deep(.imglabelsmall) {
    background: rgba(240, 248, 255, 0.5);
    position: absolute;
    text-transform: uppercase;
    font-size: 0.3rem;
    padding-top: 2px;
    font-weight: bold;
    bottom: 0;
    z-index: 9999;
    color: red;
    text-align: center;
    border: red 1px solid;
    white-space: nowrap;
    left: 0;
    width: 100%;
    line-height: 1.5em;
}

::v-deep(.thumb) {
    border: #6d6f8a 1px solid;
}

::v-deep(.thumb-svg) {
    border: #6d6f8a 1px solid;
    background: lightgray;
}

::v-deep(.v-dialog) {
    overflow: hidden !important;
}

::v-deep(.v-card__text) {
    overflow: hidden !important;
    padding: 16px;
}

.image-container {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
